import { sidekickRtkClient } from '@brightdrop/ai-sidekick/api';
import {
  entitlementsRtkClient,
  publicApi,
} from '@gm-commercial/entitlements-client';
import {
  rtkAssetsClient,
  rtkFleetPartnersClient,
  rtkOrdertrackingClient,
  rtkOrgClient,
  rtkPermissionsClient,
  rtkSafetyClient,
  rtkUsersClient,
} from '@gm-commercial/rtk-clients';

import { rtkClient } from '~/api';

/**
 * Every RTK Query client the app mounts.
 *
 * Kept as a list because two things need all of them and would otherwise each keep their own copy:
 * the store registers their middleware, and a change of locale empties their caches. A client
 * missing from the second list would go on serving responses written in a language the reader no
 * longer reads, which is the kind of omission nothing fails loudly about.
 *
 * Declared apart from the store so that anything resetting the caches can reach the list without
 * reaching the store, and so the list depends on nothing but the clients themselves.
 */
export const API_CLIENTS = [
  rtkClient,
  sidekickRtkClient,
  entitlementsRtkClient,
  publicApi,
  rtkOrgClient,
  rtkAssetsClient,
  rtkFleetPartnersClient,
  rtkOrdertrackingClient,
  rtkPermissionsClient,
  rtkSafetyClient,
  rtkUsersClient,
] as const;
